<app-common-table [actionPermission]="{pagination:false}" [tableData]="tableData" [columnHeader]="entityData?.profile?.[0]?.attributesTableHeader">
</app-common-table>